"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductAudit = void 0;
require("./product-audit.less");
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const ag_grid_react_1 = require("ag-grid-react");
const mobx_1 = require("mobx");
const product_audit_header_1 = require("./components/product-audit-header");
const button_1 = require("client/components/material/button");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const modal_1 = require("client/components/modal");
const number_formatter_1 = require("../claim-analytics/number-formatter");
const mobx_react_1 = require("mobx-react");
const store_1 = require("client/modules/reporting/store");
const store_2 = require("client/modules/users/store");
const store_3 = require("client/modules/sites/modules/sites-list/store");
const React = require("react");
const select_1 = require("client/components/material/select");
let ProductAudit = class ProductAudit extends React.Component {
    constructor(props) {
        super(props);
        this.storeData = null;
        this.selectedRow = null;
        this.showQueryManager = true;
        this.query = {
            end: new Date(),
            start: new Date(),
            siteId: "0"
        };
        this.handleSubmit = async () => {
            var _a;
            this.showQueryManager = false;
            const result = await store_1.reportsStore.loadProductAuditReport({ query: this.query });
            this.storeData.rowData = (_a = result === null || result === void 0 ? void 0 : result.productAudit) !== null && _a !== void 0 ? _a : [];
        };
        this.renderQueryModal = () => {
            var _a;
            if (this.showQueryManager) {
                const cancelButton = (React.createElement(button_1.MaterialButton, { style: { marginLeft: "1em" }, onClick: () => {
                        this.showQueryManager = false;
                    } }, "Cancel"));
                const pharmacySelect = (React.createElement(select_1.MaterialSelect, { options: this.availableOptions, onSelect: (v) => {
                        this.query.siteId = v;
                    }, label: "Pharmacy", value: (_a = this.query.siteId) !== null && _a !== void 0 ? _a : "0" }));
                const submitButton = (React.createElement(button_1.MaterialButton, { disabled: !this.query.start || !this.query.end, onClick: this.handleSubmit, primary: true }, "Submit"));
                const buttons = [submitButton, cancelButton];
                const modal = (React.createElement(modal_1.Modal, { buttons: buttons, onCancel: () => {
                        this.showQueryManager = false;
                    } },
                    React.createElement("div", null, pharmacySelect),
                    React.createElement("div", { style: { display: "flex" } },
                        this.genDate("start"),
                        this.genDate("end"))));
                return modal;
            }
        };
        this.onRowClicked = async (row) => {
            const { data } = row;
            const result = await store_1.reportsStore.loadMailMessage(data.MailID);
            this.selectedRow = result;
        };
        // E-029
        this.onButtonExport = () => {
            const params = {
                fileName: "Product Audit.csv"
            };
            this.storeData.gridApi.exportDataAsCsv(params);
        };
        this.genDate = (type) => {
            const title = type.replace(/\b\w/g, c => c.toUpperCase());
            const jsx = (React.createElement("div", { style: { paddingRight: "1em" } },
                React.createElement("h3", null,
                    title,
                    " Date: "),
                React.createElement(date_picker_1.MaterialDatePicker, { label: `${title} Date`, required: true, value: this.query[type] || "", onChange: val => {
                        mobx_1.extendObservable(this.query, { [type]: val });
                    } }),
                React.createElement("div", { style: { display: "flex", marginTop: "1em" } },
                    React.createElement(button_1.MaterialButton, { primary: true, onClick: () => {
                            mobx_1.extendObservable(this.query, { [type]: new Date() });
                        }, style: { marginRight: "1em" } }, "Today"),
                    React.createElement(button_1.MaterialButton, { onClick: () => {
                            mobx_1.extendObservable(this.query, { [type]: null });
                        } }, "Clear"))));
            return jsx;
        };
        this.storeData = {
            columnDefs: [
                {
                    enableRowGroup: true,
                    field: "pkgCode",
                    filter: "agTextColumnFilter",
                    headerCheckboxSelection: true,
                    headerName: "Package"
                },
                {
                    field: "name",
                    filter: "agTextColumnFilter",
                    headerName: "Name"
                },
                {
                    field: "description",
                    filter: "agTextColumnFilter",
                    headerName: "Description"
                },
                {
                    field: "dispensed",
                    filter: "agTextColumnFilter",
                    headerName: "Dispensed",
                },
                {
                    field: "purchased",
                    filter: "agTextColumnFilter",
                    headerName: "Purchased",
                }
            ],
            defaultColDef: {
                comparator: (a, b) => typeof a === "string"
                    ? a.localeCompare(b)
                    : a > b
                        ? 1
                        : a < b
                            ? -1
                            : 0,
                enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                filter: true,
                resizable: true,
                sortable: true
            },
            floatingFilter: true,
            frameworkComponents: {
                numberFormatter: number_formatter_1.NumberFormatter
            },
            multiSortKey: "ctrl",
            rowData: []
        };
    }
    get availableOptions() {
        const options = [];
        const isImbUser = store_2.usersStore.user.value.user;
        if (isImbUser) {
            if (store_3.sitesListStore.sites.value) {
                options.push({ id: 0, label: "All Pharmacies", value: "0" });
                store_3.sitesListStore.sites.value.forEach((site, i) => {
                    const indexStandardizer = 1;
                    options.push({
                        id: i + indexStandardizer,
                        label: site.displayName || site.name,
                        value: site.id.toString()
                    });
                });
            }
        }
        else {
            const { site } = store_2.usersStore.user.value;
            const siteOption = {
                id: site.id,
                label: site.displayName || site.name,
                value: site.id.toString()
            };
            options.push(siteOption);
        }
        return options;
    }
    render() {
        const buttons = [
            React.createElement("button", { onClick: () => {
                    this.showQueryManager = true;
                }, style: { marginLeft: "2em" }, type: "button" }, "Manage Query")
        ];
        const header = React.createElement(product_audit_header_1.ProductAuditHeader, { buttons: buttons, title: "Product Audit" });
        const agGrid = (React.createElement("div", { className: "ag-theme-balham", style: {
                height: "85%",
                width: "100%"
            } },
            React.createElement("button", { type: "button", onClick: this.onButtonExport.bind(this) }, "Export to CSV"),
            React.createElement(ag_grid_react_1.AgGridReact, { animateRows: true, columnDefs: this.storeData.columnDefs, defaultColDef: this.storeData.defaultColDef, floatingFilter: this.storeData.floatingFilter, frameworkComponents: this.storeData.frameworkComponents, groupMultiAutoColumn: true, multiSortKey: this.storeData.multiSortKey, onGridReady: params => {
                    this.storeData.gridApi = params.api;
                }, onRowClicked: this.onRowClicked, rowData: [...this.storeData.rowData], sideBar: true, suppressExcelExport: true, suppressRowClickSelection: true })));
        return (React.createElement(React.Fragment, null,
            header,
            React.createElement("br", null),
            agGrid,
            this.renderQueryModal()));
    }
};
__decorate([
    mobx_1.observable
], ProductAudit.prototype, "storeData", void 0);
__decorate([
    mobx_1.observable
], ProductAudit.prototype, "selectedRow", void 0);
__decorate([
    mobx_1.observable
], ProductAudit.prototype, "showQueryManager", void 0);
__decorate([
    mobx_1.observable
], ProductAudit.prototype, "query", void 0);
__decorate([
    mobx_1.computed
], ProductAudit.prototype, "availableOptions", null);
ProductAudit = __decorate([
    mobx_react_1.observer
], ProductAudit);
exports.ProductAudit = ProductAudit;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/product-audit/product-audit.tsx
// module id = 3979
// module chunks = 0